import { render } from "./AllNotifications.vue?vue&type=template&id=3a785272"
import script from "./AllNotifications.vue?vue&type=script&lang=js"
export * from "./AllNotifications.vue?vue&type=script&lang=js"

import "./AllNotifications.vue?vue&type=style&index=0&id=3a785272&lang=css"

import exportComponent from "/home/forge/staging.ordinocrm.com/releases/20260610000542/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__